const buildNumber = import.meta.env.VITE_CODEBUILD_BUILD_NUMBER;
const sentryEnv = import.meta.env.VITE_SENTRY_ENV;
const wafCaptcha = import.meta.env.VITE_WAF_API_URL;
const wafApiKey = import.meta.env.VITE_WAF_API_KEY;
const siteConfigProjectIds =
  import.meta.env.VITE_SITE_CONFIG_PROJECT_IDS?.split(',')
    .map((id: string) => id.trim())
    .filter(Boolean) ?? [];
const ssoAuthorizeHosts = import.meta.env.VITE_SSO_AUTHORIZE_HOSTS?.split(',')
  .map((host: string) => host.trim().toLowerCase())
  .filter(Boolean) ?? ['auth0.com'];

export const Config = {
  ssoAuthorizeHosts,
  siteConfigProjectIds,
  baseURL: import.meta.env.VITE_API_URL!,
  jiraWidgetKey: import.meta.env.VITE_JIRA_WIDGET_KEY || '',
  MUILicenseKey: import.meta.env.VITE_MUI_LICENSE_KEY || '',
  routeBasename: import.meta.env.VITE_ROUTE_BASENAME || '/',
  brandingId: import.meta.env.VITE_BRANDING_ID || 'suitebean',
  brandingName: import.meta.env.VITE_BRANDING_NAME || 'SuiteBean',
  mivaxAvailable: import.meta.env.VITE_MIVAX_AVAILABLE === 'true',
  childrenAvailable: import.meta.env.VITE_CHILDREN_AVAILABLE === 'true',
  targetLanguages: import.meta.env.VITE_TARGET_LANGUAGES?.split(',') ?? [],
  tenantGameAvailable: import.meta.env.VITE_TENANT_GAME_AVAILABLE === 'true',
  gameAnalyticsProjectId: import.meta.env.VITE_GAME_ANALYTICS_PROJECT_ID || '',
  profileFormsAvailable:
    import.meta.env.VITE_PROFILE_FORMS_AVAILABLE === 'true',
  pdfManagementAvailable:
    import.meta.env.VITE_PDF_MANAGEMENT_AVAILABLE === 'true',
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
  sentry: {
    env: sentryEnv,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release:
      sentryEnv && buildNumber ? `${sentryEnv}-${buildNumber}` : undefined,
  },
};
